/**
 * Pure view-derivation helper for /api/activity events.
 * Input shape matches what the server returns (see server/routes/activity.js).
 *
 * Output: { color, tag, description, timestampMs, steamId64 }
 *   - color: 'success' | 'warn' | 'danger' | 'muted'
 *   - tag: short label for the right-hand column
 *   - description: templated sentence for the middle column
 *   - timestampMs: numeric timestamp for sorting and display
 *   - steamId64: passed through for the clickable link
 */
export function activityView(event) {
  const ts = event.changedAt || event.detectedAt;
  const timestampMs = ts ? new Date(ts).getTime() : 0;
  const steamId64 = event.steamId64;

  if (event.type === 'cooldown') {
    if (event.kind === 'started') {
      const lvl = event.cooldownLevel || 'unknown';
      return {
        color: 'warn',
        tag: 'Cooldown',
        description: `entered cooldown (${lvl})`,
        timestampMs,
        steamId64
      };
    }
    return {
      color: 'success',
      tag: 'Cooldown',
      description: 'cooldown ended — account ready',
      timestampMs,
      steamId64
    };
  }

  if (event.type === 'ban') {
    const from = event.delta?.from;
    const to = event.delta?.to;
    switch (event.kind) {
      case 'vac':
        return { color: 'danger', tag: 'VAC Ban', description: `received a VAC ban (${from} → ${to})`, timestampMs, steamId64 };
      case 'game':
        return { color: 'danger', tag: 'Game Ban', description: `received a game ban (${from} → ${to})`, timestampMs, steamId64 };
      case 'community':
        return { color: 'danger', tag: 'Community Ban', description: 'received a community ban', timestampMs, steamId64 };
      case 'economy':
        return { color: 'danger', tag: 'Economy Ban', description: `received an economy ban (${to})`, timestampMs, steamId64 };
      default:
        break;
    }
  }

  return { color: 'muted', tag: 'Event', description: 'unknown event', timestampMs, steamId64 };
}
